import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { FeatureId } from '../../../../../Model/Product';
import { InfoTag, DarkTag } from '../../../../../components/Tags';

import { Container } from './styles';
import texts from './texts.json';

const CheckInInfo = ({
  isFirstCheckIn,
  enabledFeatures,
  weeklyWeightGoal,
}) => {
  const featureText = useMemo(() => {
    if (!enabledFeatures) {
      return null;
    }

    const hasWorkout = enabledFeatures.includes(FeatureId.WORKOUT_VIDEO_FEEDBACK);
    const hasMealPlan = enabledFeatures.includes(FeatureId.NUTRITION_PLAN);

    if (hasWorkout && hasMealPlan) {
      return texts.workoutAndMealPlan;
    }
    if (hasWorkout) {
      return texts.workoutOnly;
    }
    if (hasMealPlan) {
      return texts.mealPlanOnly;
    }
    return null;
  }, [enabledFeatures]);

  const showInfo = isFirstCheckIn || featureText || weeklyWeightGoal;

  if (!showInfo) {
    return null;
  }

  return (
    <Container>
      {isFirstCheckIn && <DarkTag>{texts.firstCheckIn}</DarkTag>}
      {featureText && <InfoTag>{featureText}</InfoTag>}
      {weeklyWeightGoal && <InfoTag>{`${texts.goalLabel} ${weeklyWeightGoal}`}</InfoTag>}
    </Container>
  );
};

CheckInInfo.propTypes = {
  isFirstCheckIn: PropTypes.bool,
  enabledFeatures: PropTypes.arrayOf(PropTypes.string),
  weeklyWeightGoal: PropTypes.string,
};

CheckInInfo.defaultProps = {
  isFirstCheckIn: false,
  enabledFeatures: [],
  weeklyWeightGoal: '',
};

export default CheckInInfo;
